import useIdentificationError from './useIdentificationError'
import useSyncIdentificationPrompt from './useSyncIdentificationPrompt'

/**
 * Required code to handle required logic when landing back from signicat connect identification.
 */
const useIdentificationLandingPage = (vehicleId, vertical) => {
    useSyncIdentificationPrompt()
    const identificationError = useIdentificationError(vehicleId, vertical)

    return { error: identificationError }
}

export default useIdentificationLandingPage
